<form class="select-wrapper-container" [formGroup]="selectForm" ui-form>
  <ui-form-item class="form-item">
    <ui-select
      [uiId]="uiId"
      [a11yLabel]="a11yLabel"
      [a11yLabelledby]="a11yLabelledby"
      [a11yDescription]="a11yDescription"
      [uiOptionHeightPx]="40"
      [uiDisabled]="disabled"
      formControlName="type"
      uiDropdownClassName="select-wrapper-dropdown-container">
      <ui-option *ngFor="let option of options" [uiLabel]="option.label" [uiValue]="option.label" uiCustomContent>
        <span>{{ option.label }}</span>
        <span class="additional-label">{{ option.additionalLabel }}</span>
      </ui-option>
    </ui-select>
  </ui-form-item>
</form>
